(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- variant swatches -> hidden id + live price ----------
  var idInput = document.getElementById('os-variant-id');
  var swatches = document.querySelectorAll('.os-swatch');
  Array.prototype.forEach.call(swatches, function (b) {
    b.addEventListener('click', function () {
      Array.prototype.forEach.call(swatches, function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      if (idInput) { idInput.value = b.getAttribute('data-id'); }
      var name = document.getElementById('cName');
      if (name) { name.textContent = b.getAttribute('data-title'); }
      var price = b.getAttribute('data-price');
      var now = document.getElementById('os-price');
      if (now && price) { now.textContent = price; }
      var sticky = document.getElementById('os-sticky-price');
      if (sticky && price) { sticky.textContent = price; }
      var bimg = document.getElementById('buyImg');
      var src = b.getAttribute('data-img');
      if (bimg && src) {
        if (reduce) {
          bimg.src = src;
        } else {
          var pre = new Image();
          bimg.classList.add('is-swap');
          pre.onload = function () { bimg.src = src; bimg.classList.remove('is-swap'); };
          pre.onerror = function () { bimg.classList.remove('is-swap'); };
          pre.src = src;
        }
      }
    });
  });

  // ---------- quantity stepper ----------
  var qv = document.getElementById('qv');
  if (qv) {
    var setQ = function (n) {
      if (isNaN(n) || n < 1) { n = 1; }
      if (n > 99) { n = 99; }
      qv.value = n;
    };
    var qm = document.getElementById('qm');
    var qp = document.getElementById('qp');
    if (qm) { qm.addEventListener('click', function () { setQ(parseInt(qv.value, 10) - 1); }); }
    if (qp) { qp.addEventListener('click', function () { setQ(parseInt(qv.value, 10) + 1); }); }
    qv.addEventListener('change', function () { setQ(parseInt(qv.value, 10)); });
  }

  // ---------- countdown ----------
  var t = document.querySelector('.timer');
  if (t) {
    var hrs = parseFloat(t.getAttribute('data-hours')) || 12;
    var key = 'oscira-timer-end';
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) { end = 0; }
    if (!end || end < Date.now()) {
      end = Date.now() + hrs * 3600 * 1000;
      try { sessionStorage.setItem(key, end); } catch (e) {}
    }
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var eh = document.getElementById('t-h');
    var em = document.getElementById('t-m');
    var es = document.getElementById('t-s');
    var tick = function () {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s < 0) { s = 0; }
      if (eh) { eh.textContent = pad(Math.floor(s / 3600)); }
      if (em) { em.textContent = pad(Math.floor((s % 3600) / 60)); }
      if (es) { es.textContent = pad(s % 60); }
    };
    tick();
    setInterval(tick, 1000);
  }

  // ---------- scroll reveal + stat counters ----------
  var reveals = document.querySelectorAll('.rv');
  var countUp = function (el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) { return; }
    var suffix = el.getAttribute('data-suffix') || '';
    var final = target.toLocaleString() + suffix;

    // Write the real number first. If requestAnimationFrame never ticks
    // (background tab, power saving, embedded webview) the correct figure is
    // already on screen instead of a permanent "0".
    el.textContent = final;
    if (reduce || typeof requestAnimationFrame !== 'function') { return; }

    var dur = 1100, t0 = null;
    var step = function (ts) {
      if (t0 === null) { t0 = ts; }
      var k = Math.min(1, (ts - t0) / dur);
      var eased = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(target * eased).toLocaleString() + suffix;
      if (k < 1) { requestAnimationFrame(step); } else { el.textContent = final; }
    };
    requestAnimationFrame(step);
    // Belt and braces: guarantee the final value even if the loop stalls.
    setTimeout(function () { el.textContent = final; }, dur + 400);
  };

  var showAll = function () {
    // Drop the hidden state entirely rather than relying on a CSS transition —
    // if transitions are frozen, adding .in alone would leave everything at
    // opacity 0.
    document.documentElement.classList.remove('js-rv');
    Array.prototype.forEach.call(reveals, function (el) { el.classList.add('in'); });
    Array.prototype.forEach.call(document.querySelectorAll('b[data-count]'), function (n) {
      if (!n.getAttribute('data-done')) { n.setAttribute('data-done', '1'); countUp(n); }
    });
  };

  if (reveals.length && 'IntersectionObserver' in window) {
    // Only now is it safe to hide things: we know we have a way to show them.
    document.documentElement.classList.add('js-rv');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) { return; }
        en.target.classList.add('in');
        var num = en.target.querySelector('b[data-count]');
        if (num && !num.getAttribute('data-done')) {
          num.setAttribute('data-done', '1');
          countUp(num);
        }
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    Array.prototype.forEach.call(reveals, function (el) { io.observe(el); });

    // Failsafe: if the observer never fires (some embedded/offscreen webviews
    // never report intersections) the page must not stay blank.
    setTimeout(function () {
      if (!document.querySelector('.rv.in')) { showAll(); }
    }, 1200);
  } else {
    showAll();
  }

  // ---------- reading progress bar ----------
  var prog = document.getElementById('osProg');
  if (prog) {
    var onScroll = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var pct = h > 0 ? (window.pageYOffset / h) * 100 : 0;
      prog.style.width = Math.max(0, Math.min(100, pct)) + '%';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- intensity dial ----------
  var wave = document.getElementById('dialWave');
  var BARS = 22;
  if (wave) {
    for (var i = 0; i < BARS; i++) { wave.appendChild(document.createElement('i')); }
  }
  var setWave = function (amp) {
    if (!wave) { return; }
    var bars = wave.children;
    for (var i = 0; i < bars.length; i++) {
      var mid = 1 - Math.abs(i - (bars.length - 1) / 2) / ((bars.length - 1) / 2);
      var h = 8 + amp * (0.35 + 0.65 * mid) * (0.7 + 0.3 * Math.random());
      bars[i].style.setProperty('--h', Math.round(h) + 'px');
      bars[i].style.animationDuration = (0.55 + (100 - amp) / 160) + 's';
      bars[i].style.animationDelay = (i * 0.035) + 's';
    }
  };
  var lvls = document.querySelectorAll('.os-lvl');
  Array.prototype.forEach.call(lvls, function (b) {
    b.addEventListener('click', function () {
      Array.prototype.forEach.call(lvls, function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      setWave(parseFloat(b.getAttribute('data-amp')) || 30);
      var ti = document.getElementById('dialTitle');
      var de = document.getElementById('dialDesc');
      if (ti) { ti.innerHTML = b.getAttribute('data-title'); }
      if (de) { de.textContent = b.getAttribute('data-desc'); }
    });
  });
  if (lvls.length) {
    var active = document.querySelector('.os-lvl[aria-pressed="true"]') || lvls[0];
    setWave(parseFloat(active.getAttribute('data-amp')) || 38);
  }

  // ---------- sticky buy bar reveals past the hero ----------
  var bar = document.querySelector('.sticky');
  var heroCta = document.querySelector('.hero .cta');
  if (bar && heroCta && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('js-sticky');
    var barIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        // en.boundingClientRect.top < 0 means the CTA has scrolled off the top
        var passed = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('show', passed);
      });
    }, { threshold: 0 });
    barIo.observe(heroCta);
    // If the observer never reports, fall back to always-visible.
    setTimeout(function () {
      if (!bar.classList.contains('show') && window.pageYOffset > 600) {
        document.documentElement.classList.remove('js-sticky');
      }
    }, 1500);
  }

  // ---------- usage carousel (auto-sliding) ----------
  var car = document.getElementById('spotCar');
  var track = document.getElementById('spotTrack');
  var dotsWrap = document.getElementById('spotDots');
  if (car && track && dotsWrap && track.children.length) {
    var slides = track.children;
    var n = slides.length;
    var idx = 0;
    var timer = null;
    var delay = parseInt(car.getAttribute('data-autoplay'), 10) || 3500;
    var dots = [];

    var render = function () {
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      for (var j = 0; j < n; j++) {
        dots[j].setAttribute('aria-selected', j === idx ? 'true' : 'false');
      }
    };
    var go = function (k) { idx = (k % n + n) % n; render(); };
    var nextSlide = function () { go(idx + 1); };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    var start = function () { if (reduce) { return; } stop(); timer = setInterval(nextSlide, delay); };
    var restart = function () { stop(); start(); };

    for (var i = 0; i < n; i++) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('role', 'tab');
      d.setAttribute('aria-label', 'Slide ' + (i + 1));
      (function (k) {
        d.addEventListener('click', function () { go(k); restart(); });
      })(i);
      dotsWrap.appendChild(d);
      dots.push(d);
    }

    var x0 = null;
    car.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    car.addEventListener('touchend', function (e) {
      if (x0 === null) { return; }
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { if (dx < 0) { nextSlide(); } else { go(idx - 1); } }
      x0 = null;
      start();
    }, { passive: true });

    car.addEventListener('mouseenter', stop);
    car.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });

    render();
    start();
  }

  // ---------- language switcher ----------
  var langSel = document.getElementById('os-lang-select');
  if (langSel) {
    langSel.addEventListener('change', function () { langSel.form.submit(); });
  }

  // ---------- buy 2 / buy 3 one-click ----------
  var deals = document.querySelectorAll('.deal');
  Array.prototype.forEach.call(deals, function (b) {
    b.addEventListener('click', function () {
      var idEl = document.getElementById('os-variant-id');
      if (!idEl || !idEl.value) { return; }
      var cta = b.querySelector('.deal__cta');
      var reset = function (msg) {
        b.disabled = false;
        if (cta) { cta.textContent = msg || b.getAttribute('data-cta'); }
      };
      b.disabled = true;
      if (cta) { cta.textContent = b.getAttribute('data-busy'); }
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: idEl.value, quantity: parseInt(b.getAttribute('data-qty'), 10) })
      }).then(function (r) {
        if (!r.ok) { throw new Error('add failed'); }
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
      }).catch(function () {
        reset(b.getAttribute('data-err'));
        setTimeout(function () { reset(); }, 3000);
      });
    });
  });

  // ---------- details peek carousel (center-focus with edge peek) ----------
  (function () {
    var dcar = document.getElementById('detCar');
    var dtrack = document.getElementById('detTrack');
    var ddots = document.getElementById('detDots');
    if (!dcar || !dtrack || !ddots || !dtrack.children.length) { return; }
    var vp = dcar.querySelector('.dcar__viewport');
    var dslides = dtrack.children;
    var dn = dslides.length;
    var didx = Math.floor(dn / 2);
    var dtimer = null;
    var ddelay = parseInt(dcar.getAttribute('data-autoplay'), 10) || 4200;
    var ddotEls = [];

    function gap() { var g = parseFloat(getComputedStyle(dtrack).columnGap); return isNaN(g) ? 16 : g; }
    function render() {
      var V = vp.clientWidth;
      var S = dslides[0].offsetWidth;
      var g = gap();
      var trackW = dn * S + (dn - 1) * g;
      var offset = V / 2 - S / 2 - didx * (S + g);
      var minOffset = Math.min(0, V - trackW);
      if (window.innerWidth >= 750) {
        // desktop: keep the row flush to the edges (no empty gutters)
        offset = Math.max(minOffset, Math.min(0, offset));
      } else {
        // mobile: keep the active card centered with a peek on each side
        offset = Math.max(minOffset, offset);
      }
      dtrack.style.transform = 'translateX(' + offset + 'px)';
      for (var i = 0; i < dn; i++) {
        if (i === didx) { dslides[i].classList.add('is-active'); } else { dslides[i].classList.remove('is-active'); }
        ddotEls[i].setAttribute('aria-selected', i === didx ? 'true' : 'false');
      }
    }
    function go(k) { didx = (k % dn + dn) % dn; render(); }
    function next() { go(didx + 1); }
    function stop() { if (dtimer) { clearInterval(dtimer); dtimer = null; } }
    function start() { if (reduce) { return; } stop(); dtimer = setInterval(next, ddelay); }
    function restart() { stop(); start(); }

    for (var i = 0; i < dn; i++) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-label', 'Slide ' + (i + 1));
      (function (k) { b.addEventListener('click', function () { go(k); restart(); }); })(i);
      ddots.appendChild(b); ddotEls.push(b);
    }
    Array.prototype.forEach.call(dslides, function (s, k) {
      s.addEventListener('click', function () { if (k !== didx) { go(k); restart(); } });
    });
    var x0 = null;
    dcar.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    dcar.addEventListener('touchend', function (e) {
      if (x0 === null) { return; }
      var dd = e.changedTouches[0].clientX - x0;
      if (Math.abs(dd) > 40) { if (dd < 0) { next(); } else { go(didx - 1); } }
      x0 = null; start();
    }, { passive: true });
    dcar.addEventListener('mouseenter', stop);
    dcar.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(render, 120); });
    render(); start();
  })();
})();